import { render } from "./plan-types.vue?vue&type=template&id=1316b919"
import script from "./plan-types.vue?vue&type=script&lang=js"
export * from "./plan-types.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__